// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// GENERATED FILE. DO NOT EDIT MANUALLY.

module.exports = '1.29.0';
